import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';
import {EnumLoginViewMode, IUser} from "../../../interfaces";
import {actionAccountCommandsRequest, actionLoginViewMode} from "../../../store/actions/user.actions";
import {ToastrService} from "ngx-toastr";
import {AppService, AuthUserService, StoreSelectorsService} from "../../../services";
import {isNullOrUndefOrEmpty, validateEmail} from "../../../common";
import {Compbaser} from "../../../components/compbaser";
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";
import {MatDialog} from "@angular/material/dialog";
import {timeout} from "../../../decorators/timeout";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],

})
export class ForgotPasswordComponent extends Compbaser implements OnInit {
    m_viewMod = EnumLoginViewMode;
    m_name = '';
    m_user: IUser;
    m_preFill = false;
    m_disableInput = false;
    @Input() hideBack = false;

    @Input()
    set userLoggedIn(i_enable: boolean) {
        if (!i_enable) return;
        this.m_preFill = true;

    }

    constructor(dialog: MatDialog,
                private translocoService: TranslocoService,
                private toastr: ToastrService,
                private appService: AppService,
                private authService: AuthUserService,
                private storeSelector: StoreSelectorsService,
                private el: ElementRef) {
        super(dialog);
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    if (!i_user || isNullOrUndefOrEmpty(i_user.username))
                        return;
                    this.m_user = i_user;
                    if (this.m_preFill) {
                        if (validateEmail(this.m_user.email)) {
                            this.m_name = this.m_user.email;
                            this.m_disableInput = true;
                        } else if (validateEmail(this.m_user.username)) {
                            this.m_name = this.m_user.username;
                            this.m_disableInput = true;
                        }
                    }
                })
        );
    }


    passFocus() {
        try {
            this.el.nativeElement.querySelector('.passField').focus();
        } catch (e) {
        }
    }

    onResetPassword() {
        if (this.userLoggedIn) {
            if (!validateEmail(this.m_name))
                return this.toastr.error(this.translocoService.translate('account.valueValidEmail', {}, this.translocoService.getActiveLang()));
        }
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {
                name:
                    `${this.translocoService.translate('account.areYouSureThisLogout2', {}, this.translocoService.getActiveLang())}?`,
                showCancel: true
            }
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                this.m_name = this.m_name.trim();
                this.storeSelector.appStore.dispatch(actionAccountCommandsRequest({
                        accountRequest: {
                            createCustomerAccount: {userName: this.m_name},
                            serverCall: 'FORGOT_PASS'
                        }
                    })
                );
                this.toastr.info(this.translocoService.translate('toast.reLogin', {}, this.translocoService.getActiveLang()));
                this.logout();
            }
        });
    }

    @timeout(333)
    logout() {
        this.authService.logout();
        this.appService.goToHomePage(false);
    }

    setViewMode(v: EnumLoginViewMode) {
        this.storeSelector.dispatch(actionLoginViewMode({loginViewMode: v}));
    }

}

